import React from 'react';
import { useSoundEnabled, toggleSound } from '../utils/soundPrefs';

/**
 * SoundToggle — persistent master mute button (UI_REVIEW §6).
 * Glass-pill styling to match the site header nav.
 */
export default function SoundToggle() {
  const soundOn = useSoundEnabled();

  return (
    <button
      onClick={() => toggleSound()}
      style={s.button}
      aria-pressed={soundOn}
      aria-label={soundOn ? 'Turn sound off' : 'Turn sound on'}
      title={soundOn ? 'Sound is on' : 'Sound is off'}
    >
      {soundOn ? (
        <svg {...iconProps}>
          <path d="M11 5 6 9H3v6h3l5 4V5z" />
          <path d="M15.5 8.5a5 5 0 0 1 0 7" />
          <path d="M18.5 5.5a9 9 0 0 1 0 13" />
        </svg>
      ) : (
        <svg {...iconProps}>
          <path d="M11 5 6 9H3v6h3l5 4V5z" />
          <path d="m16 9 5 5M21 9l-5 5" />
        </svg>
      )}
    </button>
  );
}

const iconProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

const s = {
  button: {
    pointerEvents: 'auto',
    display: 'grid',
    placeItems: 'center',
    width: 40,
    height: 40,
    borderRadius: 999,
    border: '1px solid rgba(255,255,255,0.10)',
    background: 'rgba(15, 27, 53, 0.48)',
    color: '#e2e8f0',
    cursor: 'pointer',
    backdropFilter: 'blur(18px) saturate(160%)',
    WebkitBackdropFilter: 'blur(18px) saturate(160%)',
    boxShadow: '0 12px 32px rgba(2, 6, 23, 0.26)',
  },
};
